import React from 'react';
import PropTypes from 'prop-types';

const VolleyballPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3zm11.377 13c0 .527-.038 1.04-.106 1.546-.918-.67-3.322-2.506-4.563-3.08.128-.968.43-6.262-4.979-9.707 5.46.828 9.648 5.544 9.648 11.241zM16 4.623h.047l.131.08c-1.397.46-6.776 2.72-11.126 8.204C6.399 8.132 10.787 4.623 16 4.623zM4.67 15.006c1.567-2.146 6.712-7.953 12.579-9.559a11.612 11.612 0 0 1 2.744 3.004c-1.571.526-8.496 3.186-14.24 12.498A11.349 11.349 0 0 1 4.623 16c0-.336.021-.667.047-.994zM6.275 21.9c1.377-2.286 6.679-9.903 14.143-12.711.701 1.342 1.177 2.961 1.24 4.885-6.622 3.178-10.85 9.279-11.997 11.37A11.378 11.378 0 0 1 6.275 21.9zm17.742 2.17a11.349 11.349 0 0 1-3.9 2.533c-.017-.013-.034-.03-.056-.043-2.557-1.053-5.021-3.721-6.075-5.09a33.348 33.348 0 0 1 2.966-2.888c1.72 1.789 5.344 4.66 7.065 5.489zm-13.395 1.955a27.603 27.603 0 0 1 2.574-3.64c1.292 1.81 3.76 3.789 5.315 4.706a11.37 11.37 0 0 1-2.511.28 11.305 11.305 0 0 1-5.378-1.346zm14.155-2.791c-1.856-.854-5.603-4.176-6.925-5.4 1.78-1.427 3.246-2.31 3.837-2.65.883.454 3.87 2.302 5.319 3.687a11.27 11.27 0 0 1-2.23 4.363z"
    />
  );
};

VolleyballPath.propTypes = {
  fill: PropTypes.string,
};

export default VolleyballPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/volleyball.jsx